import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './App.css';
import { Navigation, Footer, ScrollProgress, ErrorBoundary, CustomCursor } from './components';

const Home = lazy(() => import('./pages/Home'));
const Products = lazy(() => import('./pages/Products'));
const Services = lazy(() => import('./pages/Services'));
const ServiceDetails = lazy(() => import('./pages/ServiceDetails'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const NotFound = lazy(() => import('./pages/NotFound'));

const GA_MEASUREMENT_ID = 'G-2V3H1510N4';

const AppContent = () => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    if (typeof window.gtag !== 'function') return;
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  useEffect(() => {
    const lng = i18n?.resolvedLanguage || i18n?.language || 'en';
    document.documentElement.lang = lng?.toLowerCase().startsWith('ka') ? 'ka' : 'en';
  }, [i18n?.resolvedLanguage, i18n?.language]);

  return (
    <div className={`App ${isHomePage ? 'home-background' : 'black-background'}`}>
      <CustomCursor />
      <Navigation />
      <ScrollProgress />
      <main id="main-content">
        <Suspense fallback={<div className="app-route-loading" aria-live="polite">Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:serviceId" element={<ServiceDetails />} />
            <Route path="/about" element={<About />} />
            {/* Careers hidden for now — restore route + nav link when ready */}
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AppContent />
      </Router>
    </ErrorBoundary>
  );
}

export default App;


